import constant from "../const";

function getUserAgent() {
  const ua = navigator.userAgent;
  if (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) {
    return 0;
  }
  if (ua.indexOf("iPhone") > 0) {
    return 1;
  }
  // Androidタブレットを対象とする
  if (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") == -1) {
    return 0;
  }
  // iPad iPodを対象とする
  if (ua.indexOf("iPad") > 0) {
    return 1;
  }
  if (ua.indexOf("iPod") > 0) {
    return 1;
  }
  // iPad OSで「デスクトップ用Webサイトを表示」がオンになっている場合はMacintoshで判定されるため、macintoshかつタッチ操作が可能な際にiPadとして判定する
  if (ua.indexOf("Macintosh") > -1 && "ontouchend" in document) {
    return 1;
  }

  // 対象外端末の場合に-1を返却
  return -1;
}

function isNotMobileBrowser() {
  return getUserAgent() === constant.USER_AGENT_NOT_SMART_PHONE;
}

export default {
  getUserAgent,
  isNotMobileBrowser,
};
